"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var BehaviorSubject_1 = require('rxjs/subject/BehaviorSubject');
require('rxjs/add/operator/map');
require('rxjs/add/operator/distinctUntilChanged');
var Store = (function (_super) {
    __extends(Store, _super);
    function Store(_dispatcher, _backend, initialState) {
        var _this = this;
        _super.call(this, initialState);
        this._dispatcher = _dispatcher;
        this._backend = _backend;
        _backend.connect(function (state) { return _super.prototype.next.call(_this, state); });
    }
    Store.prototype.select = function (keyOrSelector) {
        if (typeof keyOrSelector === 'string' ||
            typeof keyOrSelector === 'number' ||
            typeof keyOrSelector === 'symbol') {
            return this.map(function (state) { return state[keyOrSelector]; }).distinctUntilChanged();
        }
        else if (typeof keyOrSelector === 'function') {
            return this.map(keyOrSelector).distinctUntilChanged();
        }
        else {
            throw new TypeError("Store@select Unknown Parameter Type: "
                + ("Expected type of function or valid key type, got " + typeof keyOrSelector));
        }
    };
    Store.prototype.getState = function () {
        return this.value;
    };
    Store.prototype.dispatch = function (action) {
        this._dispatcher.dispatch(action);
    };
    Store.prototype.next = function (action) {
        this._dispatcher.next(action);
    };
    Store.prototype.error = function (error) {
        this._dispatcher.error(error);
    };
    Store.prototype.replaceReducer = function (reducer) {
        this._backend.replaceReducer(reducer);
    };
    return Store;
}(BehaviorSubject_1.BehaviorSubject));
exports.Store = Store;



/*****************
 ** WEBPACK FOOTER
 ** ./~/@ngrx/store/dist/store.js
 ** module id = 227
 ** module chunks = 0
 **/